import React, { useEffect, useState } from 'react'
import {
  Button,
  ButtonToolbar,
  Col,
  Form,
  Image,
  InputGroup,
  OverlayTrigger,
  Row,
  Table,
  Tooltip
} from 'react-bootstrap'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { BsArrowClockwise, BsPlusLg, BsSearch } from 'react-icons/bs'
import { createSearchParams, useNavigate } from 'react-router-dom'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import detailImg from '../../../images/Detail.svg'
import {
  PAGE_ORG_RIGHT_ADD,
  PAGE_ORG_RIGHT_DETAIL
} from '../../../router/routes'
import imgUser from '../../../images/user.png'
import { getRightOrgAPI } from '../../../services/right-org'
import UseAllOrganization from '../../../hooks/use-org-all'
import { BODYORGRIGHT } from '../../../Constants'
import { Controller, useForm } from 'react-hook-form'
import SpinnerLoading from '../../../components/spinner-loading'
import AutocompleteMulti from '../../../components/AutocompleteMulti'

function AssetOrg() {
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm()
  const [page, setPage] = useState(1)
  const [totalLimits, setTotalLimits] = useState(1)
  const [totalRows, setTotalRows] = useState(0)
  const [details, setDetails] = useState([])
  const optionOrg = UseAllOrganization([])
  const [isLoading, setIsLoading] = useState(true)
  const [orgMuti, setOrgMuti] = useState([])

  let bodyQuery = JSON.parse(localStorage.getItem(BODYORGRIGHT)) || {}
  const [filterBody, setFilterBody] = useState(bodyQuery)

  useEffect(() => {
    let d = JSON.parse(localStorage.getItem(BODYORGRIGHT)) || {}
    if (d.searchs) {
      setValue('search', d.searchs)
    }
    if (d.statusOrgIdList?.length > 0) {
      const org_id = d?.statusOrgIdList.map((t) => {
        let _vel = optionOrg.find((item) => item.value === t)
        return _vel
      })
      setOrgMuti(org_id)
    }
  }, [optionOrg, setValue])

  useEffect(() => {
    let d = JSON.parse(localStorage.getItem(BODYORGRIGHT)) || {}

    const body = {
      ...d,
      page: d?.page ?? 1
    }

    getRightOrg(body)
  }, [])

  const getRightOrg = async (body) => {
    setPage(body.page)
    setFilterBody(body)
    setIsLoading(true)
    localStorage.setItem(BODYORGRIGHT, JSON.stringify(body))
    const res = await getRightOrgAPI(body)
    setIsLoading(false)
    if (!res) return
    if (res.status) {
      setDetails(res.result)
      setTotalRows(res.totalRows)
      setTotalLimits(res.totalLimits)
    } else {
      setDetails([])
      setTotalRows(0)
      setTotalLimits(0)
    }
    setIsLoading(false)
  }

  const navigate = useNavigate()

  const handleDetail = (d) => {
    navigate({
      pathname: PAGE_ORG_RIGHT_DETAIL,
      search: `?${createSearchParams({
        username: d.username,
        org: d.org_id
      })}`
    })
  }

  const clearSearch = () => {
    setValue('search', '')
    setOrgMuti([])
    const body = {
      page: 1,
      searchs: '',
      statusOrgIdList: []
    }
    getRightOrg(body)
  }

  const onSearch = (d) => {
    setIsLoading(false)

    const body = {
      ...filterBody,
      page: 1,
      searchs: d.search
    }
    getRightOrg(body)
    setIsLoading(true)
  }

  return (
    <>
      <Row>
        <NavTitle>
          <TextNavTitle>Organization Right</TextNavTitle>
        </NavTitle>
      </Row>
      <Col xl={12}>
        <CardCustom border="0" className="h-full mt-2">
          <div className="p-3 row">
            <div className="col-2">
              <label className="small">Total: {totalRows}</label>
            </div>
            <div className="d-flex justify-content-end col-10 gap-2">
              <div className="">
                {' '}
                <div className="d-flex gap-2">
                  <Form onSubmit={handleSubmit(onSearch)}>
                    <Form.Group style={{ minWidth: 300 }}>
                      <Controller
                        name={'search'}
                        control={control}
                        render={({ field: { onChange, value = '' } }) => (
                          <InputGroup className="">
                            <InputGroup.Text className="bg-white border-end-0  text-muted">
                              <BsSearch />
                            </InputGroup.Text>
                            <Form.Control
                              value={value}
                              placeholder="Code/ Username"
                              onChange={onChange}
                              className="border-start-0 ps-0 placeholder-text"
                            />
                          </InputGroup>
                        )}
                      />
                    </Form.Group>
                  </Form>
                  <div style={{ minWidth: 250 }}>
                    <AutocompleteMulti
                      options={optionOrg}
                      value={orgMuti}
                      isClearable={true}
                      placeholder="Org Right"
                      onChange={(e) => {
                        setOrgMuti(e)

                        const body = {
                          ...filterBody,
                          page: 1,
                          // searchs: d.search
                          statusOrgIdList: e.map((o) => o.value)
                        }
                        getRightOrg(body)
                      }}
                    />
                  </div>
                </div>
              </div>

              <Button
                size="sm"
                type="button"
                variant="light"
                onClick={() => clearSearch()}
                className="text-primary border-0 "
              >
                <BsArrowClockwise />
              </Button>
              <Button
                size="sm"
                style={{ minWidth: 150 }}
                onClick={() => navigate(PAGE_ORG_RIGHT_ADD)}
              >
                <BsPlusLg /> Add Right
              </Button>
            </div>
          </div>
          <Table hover responsive>
            <thead
              className="bg-hrms"
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className="fw-light font-title-table">
                <th className="fw-normal p-4 pt-0 pb-2 pe-1">#</th>
                <th className="fw-normal">Image</th>
                <th className="fw-normal">Code</th>

                <th
                  className="fw-normal"
                  style={{
                    whiteSpace: 'nowrap',
                    maxWidth: '200px',
                    minWidth: '200px'
                  }}
                >
                  Name
                </th>
                <th className="fw-normal">Department</th>

                <th className="fw-normal " style={{ whiteSpace: 'nowrap' }}>
                  Org Right
                </th>

                <th className="fw-normal text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {details?.length > 0 ? (
                details.map((d, i) => (
                  <tr className="small fw-light align-middle">
                    <td> {page * totalLimits - totalLimits + i + 1}</td>
                    <td>
                      <Image
                        style={{ width: '40px', borderRadius: '50%' }}
                        src={d?.img_url ?? imgUser}
                      />
                    </td>
                    <td>{d.code}</td>
                    <td>
                      {d.title_en} {d.name_en} {d.surname_en}
                    </td>{' '}
                    <td>{d.department}</td>
                    <td className="">
                      {' '}
                      <div className="">
                        {d?.right &&
                          d?.right
                            .filter((item) => item.right_checked)
                            .map((o, index) => {
                              const rightDetail = o.right_detail.find(
                                (x) => x.status_checked
                              )
                              return (
                                <div className="mb-2" key={index}>
                                  <span className="">
                                    <span className="pb-2">{o?.right_org}</span>
                                    <span
                                      style={{
                                        backgroundColor:
                                          rightDetail?.status_id === 1
                                            ? '#EAF3FC'
                                            : '#F3F4F5',
                                        padding: 15
                                      }}
                                      className="pt-1 pb-1 small ms-2 text-center"
                                    >
                                      {rightDetail?.status_name}
                                    </span>
                                  </span>
                                </div>
                              )
                            })}
                      </div>
                    </td>
                    <td>
                      <div className="d-flex justify-content-center ">
                        <ButtonToolbar>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-detail">Detail</Tooltip>
                            }
                          >
                            <Button
                              variant="btn btn-outline-primary"
                              className="border-0 d-flex justify-content-center"
                              size="sm"
                              style={{
                                width: '32px',
                                height: '32px'
                              }}
                              onClick={() => handleDetail(d)}
                            >
                              <span>
                                <Image src={detailImg} style={{ width: 20 }} />
                              </span>
                            </Button>
                          </OverlayTrigger>
                        </ButtonToolbar>
                      </div>
                    </td>
                  </tr>
                ))
              ) : isLoading ? (
                <tr className="mb-0">
                  <td className="text-center" colSpan={13}>
                    <SpinnerLoading />
                  </td>
                </tr>
              ) : (
                <tr className="fw-light ">
                  <td colSpan={6} className="text-center">
                    - No data -
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="pt-3">
            <PaginationControl
              page={page}
              total={totalRows}
              limit={totalLimits}
              changePage={(p) => {
                const body = {
                  ...filterBody,
                  page: p
                }
                getRightOrg(body)
                // localStorage.setItem(PAGEORGRIGHT, p ?? 1)
              }}
              ellipsis={1}
            />
          </div>
        </CardCustom>
      </Col>
    </>
  )
}

export default AssetOrg
